export default "__VITE_ASSET__CORGvPIb__"